import { r as registerInstance, c as createEvent, h } from './index-d4808923.js';
import { b as bem } from './index.esm-7182addc.js';

const gravityRadioGroupCss = ".gravity-radio-group{display:flex;flex-direction:column;gap:4px}";
const GravityRadioGroupStyle0 = gravityRadioGroupCss;

const generateClassNames = bem('gravity-radio-group');
const GravityRadioGroup = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.selected = createEvent(this, "selected", 5);
        this.options = undefined;
        this.size = 'medium';
    }
    render() {
        var _a;
        return (h("div", { key: '3f5d9dea162cf381b4ade3f83a54483e3f75a54d', class: generateClassNames() }, (_a = this.options) === null || _a === void 0 ? void 0 : _a.map((option) => (h("gravity-radio", { id: option.id, name: "name", disabled: option.disabled, checked: option.checked, onClicked: () => this.selected.emit(option.id), size: this.size }, option.label)))));
    }
};
GravityRadioGroup.style = GravityRadioGroupStyle0;

export { GravityRadioGroup as gravity_radio_group };

//# sourceMappingURL=gravity-radio-group.entry.js.map